<template>
  <commona :data="config"></commona>
</template>
<script>
import commona from "./commona.vue";
export default {
  components: { commona },
  data() {
    return {
      config: {
        title: '违章费用',
        urlKey: '/peccancy',
        formId: 'weizhang',
        item: {
          carId: 0,
          carNo: "",
          peccancyCost: 0,
          peccancyDate: Date.now(),
          cardNo: "",
          mileage: 0,
          proofList: [],
          peccancyStation: "",
          peccancyVolume: 0,
          remainVolume: 0,
          remark: "",
          type: "",
          unitPrice: 0,
        },
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pay/carViolation.vue